import React from "react";
import { Redirect } from "react-router-dom";

export const Dashboard = () => {
  return <Redirect to="/soc/export-data" />;
};
